import { useCallback, type Dispatch, type SetStateAction } from 'react';
import type { WhatsappEditTemplate } from 'types/templates';
import type { SmartTemplateAiPayload } from './smartTemplateAiTypes';
import { applyLegacyAiTextToBody, applySmartTemplatePayloadToTemplate } from './applyAiGeneratedTemplate';

export type UseApplyGeneratedTemplateToFormParams = {
  setSelectedTemplate: Dispatch<SetStateAction<WhatsappEditTemplate>>;
  /** Updates module-level body variable counter used when inserting {{n}} in the editor. */
  syncBodyVariableIndexFromText: (bodyText: string) => void;
};

export function useApplyGeneratedTemplateToForm({
  setSelectedTemplate,
  syncBodyVariableIndexFromText,
}: UseApplyGeneratedTemplateToFormParams) {
  const applySmartPayload = useCallback(
    (payload: SmartTemplateAiPayload) => {
      setSelectedTemplate((prev) => {
        const next = applySmartTemplatePayloadToTemplate(prev, payload);
        const body = next.components.find((c) => c.type === 'BODY')?.text ?? '';
        syncBodyVariableIndexFromText(body);
        return next;
      });
    },
    [setSelectedTemplate, syncBodyVariableIndexFromText],
  );

  const applyLegacyPlainText = useCallback(
    (text: string) => {
      setSelectedTemplate((prev) => {
        const next = applyLegacyAiTextToBody(prev, text);
        const body = next.components.find((c) => c.type === 'BODY')?.text ?? '';
        syncBodyVariableIndexFromText(body);
        return next;
      });
    },
    [setSelectedTemplate, syncBodyVariableIndexFromText],
  );

  return { applySmartPayload, applyLegacyPlainText };
}
